export class Permission {
    Id: number;
    Name: string;
    Description: string;
    ControlMenuId: number;

    constructor(name: string, description: string) {
        this.Name = name;
        this.Description = description;
    }
}
